export default "__VITE_ASSET__46e7f326__"